import { createCrudThunks } from "./utils/thunk";
import { createCrudReducer } from "./utils/reducer";
import api from "./StatusReserva/api";

const label = "Status de reserva";
const entidade = "statusReserva";

export const { get, add, update, deletar } = createCrudThunks(entidade, api, label);
const StatusReservaReducer = createCrudReducer(entidade, { get, add, update, deletar });

export {
  get as getStatusReserva,
  add as addNewStatusReserva,
  update as updateStatusReserva,
  deletar as deleteStatusReserva,
};

export default StatusReservaReducer;
